var msg = new Array();
msg['ERR_PRIVACY']='您必须接收相关条款';
msg['ERR_MISSINGFIELDS']='请正确填写所有字段';
msg['ERR_FILLEMAILFIELD']='请在空白处填写邮箱';
msg['ERR_USEREXISTS']='用户已经存在.';
msg['ERR_INVALIDMAIL']='无效电子邮箱';
msg['ERR_CLIENTMANDATORYFIELDS']='标记处为必填字段';
msg['ERR_NOSIZESELECTED']='您必须先选择尺码';
msg['ERR_LOGINREQUIRED']='您必须先登录账户';
msg['ERR_LOGININVALID']='电子邮箱或密码不正确';
msg['ERR_CARRIERMISSING']='您必须选择运输类型';
msg['ERR_CARRIER_COST_MISSING']='对于国家，物流和包裹重量没有任何关税可适用。';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='仅启用订单预定，运费将通过电子邮箱发送通知';
msg['MSG_ADDEDTOWISHLIST']='商品已添加到愿望列表';
msg['MSG_ADDEDTOCART']='商品已添加到购物车';
msg['MSG_REMOVEDFROMCART']='从购物车中移除的产品';
msg['MSG_DELETEALLPRODUCTS']='您确定要从购物车中删除所有产品吗？';
msg['DELETEALLPRODUCTSERROR']='从购物车中可移除产品时出错';
msg['MSG_WAIT']='请等待...';
msg['MSG_SUBJECT_PRODUCTSHARE']='与您分享了一些东西';
msg['MSG_SENDER_PRODUCTSHARE']='您的名字';
msg['MSG_NEWSLETTER_COMPLETED']='注册成功';
msg['MSG_MESSAGE_PRODUCTSHARE']='消息';
msg['MSG_MAILSENT']='邮件已发送';
msg['MSG_MIXED_INTANGIBLE']='购物车中的产品无法与所选产品一起购买。';
msg['MSG_MIXED_CART']='购物车中的产品不能与所选产品一起购买，因为它们在不同的仓库中。';
msg['MSG_INSUFFICIENT_STOCK']='目前该商品的数量不足';
msg['MSG_APPLIEDVATCHANGED']='帐单信息更改后，应用于您订单的增值税已更新。';
msg['MSG_GENERIC_ERROR']='很抱歉，检测到出现错误';
msg['MSG_COUPON_ERROR']='输入的优惠代码无效';
msg['MSG_COUPON_VALID']='输入的优惠券代码已成功验证。';
msg['MSG_RECOVEREMAILSENT']='检查您的电子邮件并输入代码以确认密码更改。';
msg['MSG_RECOVEREMAILSENT_ERROR'] = '注意:您尚未使用当前的Email注册或者您已经重置了新密码';
msg['MSG_SUBSCRIPTION_FAILURE']='确保您没有任何其他已活跃的订阅。';
msg['MSG_EXTRAUELIMIT']='您的最低订单金额不能少于2000.00欧;';
msg['MSG_RULE_REJECT']='产品无法添加到购物车';
msg['LABEL_ARTICLES']='商品';
msg['LABEL_WARNING']='注意';
msg['LABEL_NOTAPPLICABLE']='不适用';
msg['LABEL_ALREADYREGISTEREDUSERES']='用户已经存在';
msg['LABEL_SENTINVITES']='邀请已经发送';
msg['LABEL_NOTSENTINVITES']='邀请未发送';
msg['LABEL_INVITES_ALREADY_SENT']='已邀请用户';
msg['LABEL_SUBMIT']='发送';
msg['LABEL_SELECTALL']='选择全部';
msg['MSG_MESSAGE_SENT']='信息已发送';
msg['MSG_RETURN_REQUEST_SUCCESS'] = '成功创建退货请求';
msg['MSG_SAVE_SUCCESS'] = '保存成功';
msg['MSG_SUBSCRIBED'] = '您已注册成功';
msg['MSG_PROFILECONSENT_SAVED'] = '您的联系偏好设置已更新';
msg['wrongpassword'] = '输入的密码的不正确';
msg['passwordnotcomplex'] = '新密码过于简单，请重新设置';
msg['MSG_PASSWORD_OK'] = '密码修改成功';
msg['MSG_PASSWORD_NOT_EQUAL'] = '密码不匹配';
msg['MSG_PRIVACY_POLICY'] = '您必须接受隐私政策';
msg['MSG_SUBSCRIPTION_NO_RENEWABLE'] = '过期日期太久，无法续订';
msg['MSG_GIFTCARD_SUCCESS'] = '您的礼品卡已被接受';
msg['INVALID_GIFTCARD'] = '无效的礼品卡';
msg['ERR_REWIXSYNC_URL']= '无效的网址';
msg['msg.form.invalidtype'] = '发生错误。请联系管理部门报告以下情况： "联系人类型无效或缺失。"';
msg['login.user.unexisting'] = "用户不存在";
msg['msg.form.invalidemail'] = '电子邮件无效或缺失';
msg['msg.form.invalidrecipients'] = '发生错误。请联系管理部门报告以下情况： "联系人收件人无效或缺失。"';

var portal_livestock_available='可用';
var portal_livestock_soldout='已售空';

var activity_online_shop = '在线商店';
var activity_shop = '商店';
var activity_private_sales = '零售';
var activity_outlet = 'outlet';
var activity_online_outlet = '线上outlet';
var activity_store_chain = '连锁店';
var activity_purchasing_group = '采购团体';
var activity_broker = '经纪人/代理人';
var activity_ebay_amazon = 'ebay/amazon 商店';
var activity_other = '其他';

var general="通用";
var general_personaldata='个人信息';
var general_olduser='用户已存在';
var general_newuser='新用户';
var general_username="用户名";
var general_password="密码";
var general_contacts="联系人";
var general_phone="电话";
var general_skype="Skype";
var general_website="网站";
var general_fax="传真";
var general_firstname='名字';
var general_lastname='姓';
var general_company='公司';
var general_birth='出生日期';
var general_code='代码';
var general_model='款式';
var general_quantity='所需数量;';
var general_availability='可用性;';
var general_price='价格';
var general_warning='警告';
var general_dispatchto='收货人';
var general_careof='和/或';
var general_vat='税号';
var general_address='地址';
var general_addresstype='街道';
var general_addressnumber='门牌号';
var general_city='城市;';
var general_prov='省份';
var general_zip='邮编';
var general_mobile='手机号码';
var general_notes='备注';
var general_orders='订单';
var general_fgfdiscounts='好友与折扣';
var general_myprofile='个人资料';
var general_pieces='件';
var general_size_table='尺码表';
var general_details='细节';
var general_invoice='发票';
var general_creditnote='信用券';
var general_cart= '购物车';
var general_country='国家';
var general_carrier='快递';
var general_dispatch_address='收货地址';
var general_invoice_address='发票地址';
var general_receive_newsletter='接收电子报';
var general_copydispatchfrombilldata='复制账单信息';
var general_instructions="说明";
var general_add="添加";
var general_status="状态";
var general_toomanyfilters="您已达到允许的最大过滤器数量。";

var help_addresstype='街道，路, ...';
var help_address='输入街道名称';
var help_dispatchmobile='输入您的电话号码，以便快递可以联系您送货。';
var help_ordercfpiva='将此字段留空; 订单将自动应用增值税';
var help_cf='输入您的税号';

var buttons_save='保存';
var buttons_changepw='修改密码';
var buttons_close='关闭';
var buttons_continue='继续';
var buttons_confirm='确认';
var buttons_cancel='取消';
var buttons_invite='已发送';
var buttons_continueshopping='继续购物';
var buttons_gocheckout='前往购物车';

var messages_product_soldout='产品已售空';
var messages_noselection='您没有选择任何物品';
var messages_invaliddata='正确填写所有空白处';
var messages_recoverpassword='找回密码';
var messages_recoverpassword_info='输入您注册时使用的电子邮件地址。 <br/>已经发送了一封电子邮件到您的邮箱，其中包含设置新密码的说明。';
var messages_invitefriends='邀请好友';
var messages_confirmpassword='确认密码';
var messages_sendingmail='发送邮件中';
var messages_mailsent='邮件发送成功。';
var messages_password='密码';
var messages_confirmpassword='确认密码';
var messages_requiredfield='必填选项';

var subscribe_personaldata='个人资料处理';
var subscribe_privacyintro='注册; 请您阅读隐私法规并授权处理您的个人数据。';
var subscribe_privacydisclaimer='您必须接受隐私政策才能完成注册。'
var subscribe_privacy1='签名人确定已阅读并接受了隐私政策。';
var subscribe_privacy2='签名人授权将其数据传达给第三方公司以进行商业行为（可选）';

var order_status='状态'
var order_date='日期'
var order_dispatchdate='已派送';

var returnedgoods_requests="请求退货";
var returnedgoods_motivations="退货原因";
var returnedgoods_requestcode="退货代码";
var returnedgoods_requestdate="已请求";
var returnedgoods_motivations_1="商品不是我喜欢的";
var returnedgoods_motivations_2="商品是太大/太小";
var returnedgoods_motivations_3="商品是破损的";
var returnedgoods_motivations_4="收到的产品与请求的产品不相符";
var returnedgoods_motivations_5="收到的包裹无商品";
var returnedgoods_motivations_other="其他";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='待确认';
i18nOrderStatus[1]='付款中';
i18nOrderStatus[2]='已确认';
i18nOrderStatus[3]='已发货';
i18nOrderStatus[4]='已派送';
i18nOrderStatus[5]='已预定';
i18nOrderStatus[6]='Dropshipping';
i18nOrderStatus[2000]='已取消';
i18nOrderStatus[2001]='错误';
i18nOrderStatus[3001]='处理中';
i18nOrderStatus[3002]='已准备好';

i18nOrderStatus[1000]='付款已取消';
i18nOrderStatus[2002]='付款验证失败';
i18nOrderStatus[2003]='已退还';
i18nOrderStatus[2005]='已拒绝';
i18nOrderStatus[3003]='待发货';
i18nOrderStatus[5001]='未授权';
i18nOrderStatus[5002]='已授权';
i18nOrderStatus[5003]='Dropshipping - 成长中';